module.exports = __webpack_public_path__ + "assets/img/track-bottom-text-en.de174790.png";